export default {"src":"/_next/static/media/ebay.27ecee46.svg","height":336,"width":336};